import React, { useState } from "react";

function Counter({ min = 1, max = 20, onChange }) {
    const [count, setCount] = useState(min);

    const updateCount = (value) => {
        const newValue = Math.max(min, Math.min(max, value));
        setCount(newValue);
        if (onChange) onChange(newValue);
    };

    const increment = () => updateCount(count + 1);
    const decrement = () => updateCount(count - 1);

    return (
        <div className='flex  w-full max-w-xs mx-auto text-[14px]'>
            <button
                onClick={decrement}
                className='w-12 rounded-s-[5px] border-gray-300 border-[1px] border-r-0 bg-gray-100  text-gray-700 hover:bg-gray-300 active:scale-95 transition'
                disabled={count <= min}>
                –
            </button>

            <input
                type='number'
                inputMode='numeric'
                pattern='[0-9]*'
                className='text-center w-full py-2 border rounded-none border-gray-300  focus:outline-none focus:ring-2 focus:ring-blue-500 '
                value={count}
                onChange={(e) => updateCount(Number(e.target.value))}
                min={min}
                max={max}
            />

            <button
                onClick={increment}
                className='w-12 rounded-e-[5px] border-gray-300 border-[1px] border-l-0 bg-gray-100  text-gray-700 hover:bg-gray-300 active:scale-95 transition'
                disabled={count >= max}>
                +
            </button>
        </div>
    );
}

export default Counter;
